import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { OrderedMap } from 'immutable';
import get from 'lodash/get';

const propTypes = {
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
};

const LicensePlateModalAddVehicleLabel = ({ vehicles }) => {
  if (get(vehicles, 'size', 0) > 0) {
    return (<FormattedMessage
      id="common.or-add-new-vehicle"
      defaultMessage="OR ADD A NEW VEHICLE"
    />);
  }
  return (<FormattedMessage
    id="common.add-new-vehicle"
    defaultMessage="ADD A NEW VEHICLE"
  />);
};

LicensePlateModalAddVehicleLabel.propTypes = propTypes;
export default LicensePlateModalAddVehicleLabel;
